<svg:g class="pointer" [style.opacity]="pointer.opacity">
  <rect [attr.x]="pointer.positionX - 3" [attr.width]="6" [attr.y]="35" [attr.height]="30"></rect>
  <line [attr.x1]="pointer.positionX" [attr.y1]="35" [attr.x2]="pointer.positionX" [attr.y2]="65"></line>

  <!-- INTERSECTION -->
  <g class="intersection">
    <line [attr.x1]="pointer.intersection.position.x - 2"
          [attr.y1]="pointer.intersection.position.y - 2"
          [attr.x2]="pointer.intersection.position.x + 2"
          [attr.y2]="pointer.intersection.position.y + 2">
    </line>
    <line [attr.x1]="pointer.intersection.position.x - 2"
          [attr.y1]="pointer.intersection.position.y + 2"
          [attr.x2]="pointer.intersection.position.x + 2"
          [attr.y2]="pointer.intersection.position.y - 2">
    </line>
    <circle [attr.cx]="pointer.intersection.position.x" [attr.cy]="pointer.intersection.position.y"></circle>
  </g>
</svg:g>
